import isEqual from 'fast-deep-equal';

export { isEqual };
